import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startMyPayslipTour() {
  const steps = [
    {
      popover: {
        title: "Phiếu lương cá nhân — Production tour",
        description:
          "Trang này chỉ hiện phiếu lương đã được CEO duyệt và Kế toán công bố. Bạn có thể lọc theo năm/tháng và mở chi tiết từng kỳ.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    [
      '[data-tour="hrm-my-payslip-header"]',
      "Tiêu đề trang",
      "Bên phải có Production tour (hướng dẫn nhanh) và Documentation (tài liệu chi tiết về cách đọc phiếu lương).",
      "bottom",
    ],
    [
      '[data-tour="hrm-my-payslip-dashboard"]',
      "Tổng quan",
      "Số phiếu đã công bố, thực lĩnh kỳ gần nhất, tổng thực lĩnh và tổng tăng ca — tính trên tập đang lọc.",
      "bottom",
    ],
    [
      '[data-tour="hrm-my-payslip-filter"]',
      "Bộ lọc",
      "Tìm theo tháng/mã kỳ; lọc nâng cao theo năm và tháng. Nút làm mới tải lại danh sách từ hệ thống.",
      "bottom",
    ],
    [
      '[data-tour="hrm-my-payslip-list"]',
      "Danh sách phiếu lương",
      "Desktop: bảng kỳ lương. Mobile: thẻ từng tháng. Bấm một dòng để mở modal chi tiết (thu nhập, khấu trừ, tài khoản nhận lương).",
      "top",
    ],
  ];

  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang rồi thử lại.");
    return;
  }

  driver({
    showProgress: true,
    smoothScroll: true,
    popoverClass: "hrm-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    steps,
  }).drive();
}
